import { createSlice } from "@reduxjs/toolkit";

import { getTaskType, reassignTask, submitAssignInventory } from "./taskActions";

const initialState = {
  loading: false,
  submitLoading: false,
  trainingData: [], // Cached training data
  lastFetched: 0, // Timestamp of the last fetch
  taskTypes: [],
  activeUsers: []
};

const taskSlice = createSlice({
  name: "task",
  initialState,
  reducers: {
    setTrainingData: (state, { payload }) => {
      state.trainingData = payload.data || [];
      state.lastFetched = payload.lastFetched || Date.now();
    },
    resetTaskState() {
      return initialState; // Reset to the initial state
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(reassignTask.pending, (state) => {
        state.loading = true;
      })
      .addCase(reassignTask.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(reassignTask.rejected, (state) => {
        state.loading = false;
      });

    builder
      .addCase(submitAssignInventory.pending, (state) => {
        state.submitLoading = true;
      })
      .addCase(submitAssignInventory.fulfilled, (state) => {
        state.submitLoading = false;
      })
      .addCase(submitAssignInventory.rejected, (state) => {
        state.submitLoading = false;
      });

    builder.addCase(getTaskType.pending, (state) => {
      state.loading = true;
    }).addCase(getTaskType.fulfilled, (state, { payload }) => {
      state.loading = false;
      console.log(state, payload, ':::::::::::');
      state.taskTypes = payload.data?.taskTypes || [];
      state.activeUsers = payload.data?.activeUsers || []
    }).addCase(getTaskType.rejected, (state) => {
      state.loading = false;
    })
  },
});

export const { setTrainingData, resetTaskState } = taskSlice.actions;

export default taskSlice.reducer;
